import { PlusOne } from "@mui/icons-material";
import { Box, Fab, Grid2 } from "@mui/material";
import React from "react";
import { UserDetailView } from "../../../components/Users";
import AccountUserList from "../../../components/Users/AccountUserList";

interface AccountUsersProps {
  accountId: number;
  administrationAccount: boolean;
  readOnly: boolean;
}

const AccountUsers = ({
  accountId,
  administrationAccount,
  readOnly,
}: AccountUsersProps) => {
  const [selectedUser, setSelectedUser] = React.useState<number | null>(null);
  const [refreshUsers, setRefreshUsers] = React.useState(false);

  const handleClose = () => {
    setSelectedUser(null);
    setRefreshUsers((prev) => !prev);
  };

  return (
    <Box>
      <Grid2 container spacing={4}>
        <Grid2 size={4} sx={{ borderRight: "2px" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {!readOnly && (
              <Fab
                color="primary"
                disabled={selectedUser === 0}
                onClick={() => setSelectedUser(0)}
              >
                <PlusOne />
              </Fab>
            )}
          </Box>

          <AccountUserList
            accountId={accountId}
            onUserSelected={setSelectedUser}
            refreshTrigger={refreshUsers}
          />
        </Grid2>
        <Grid2 size={8}>
          {selectedUser !== null && (
            <UserDetailView
              accountId={accountId}
              administrationAccount={administrationAccount}
              userId={selectedUser}
              mode={selectedUser === 0 ? "create" : "edit"}
              onFinish={handleClose}
              readOnly={readOnly}
            />
          )}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default AccountUsers;
